import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type {
  CategoryDto,
  CreateCategoryRequest,
  UpdateCategoryRequest,
} from './types';

const QK_LIST = ['categories'] as const;

export function useCategories() {
  return useQuery({
    queryKey: QK_LIST,
    queryFn: async () => (await apiClient.get<CategoryDto[]>('/api/categories')).data,
  });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CreateCategoryRequest) =>
      (await apiClient.post<CategoryDto>('/api/categories', request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useUpdateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: UpdateCategoryRequest }) =>
      (await apiClient.put<CategoryDto>(`/api/categories/${id}`, request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}

export function useDeleteCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/categories/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK_LIST }),
  });
}
